import { initializeApp } from 'firebase/app'
import { getFirestore, doc, getDoc, updateDoc, increment } from 'firebase/firestore'

// const firebaseConfig = { // ステージング
//   apiKey: "AIzaSyA0NkjEfIJfWFy-H-eZgrIJP43Rdn6_Un0",
//   authDomain: "shinitori-portal-staging.firebaseapp.com",
//   projectId: "shinitori-portal-staging",
//   storageBucket: "shinitori-portal-staging.firebasestorage.app",
//   messagingSenderId: "568258938698",
//   appId: "1:568258938698:web:7579834874568767c923b3",
//   measurementId: "G-YTBVFEC0L4"
// };

const firebaseConfig = { // 本番
  apiKey: "AIzaSyAnDLJ9iPk7FRSTZZIf0s8a7Fdxwu4Cp7U",
  authDomain: "shinitori-portal.firebaseapp.com",
  projectId: "shinitori-portal",
  storageBucket: "shinitori-portal.firebasestorage.app",
  messagingSenderId: "385242618953",
  appId: "1:385242618953:web:d3e60f85f9acfe494f3398",
  measurementId: "G-Q168TWKX1T"
};

// Firebase 初期化
const app = initializeApp(firebaseConfig)
const db = getFirestore(app)

export type ForumReactions = {
  seen?: number
  hug?: number
  ally?: number
  [key: string]: number | undefined
}

/**
 * Firestoreからリアクションを取得する
 */
export async function fetchForumReactions(forumId: string): Promise<ForumReactions> {
  const ref = doc(db, 'forum_reactions_counts', forumId)
  const snap = await getDoc(ref)

  if (snap.exists()) {
    return snap.data() as Record<string, number>
  }
  return {}
}

// export const updateReactionCounts = async (container: HTMLElement, forumId: string) => {
//   const reactions = await fetchForumReactions(forumId)

//   const counters = container.querySelectorAll<HTMLElement>('.reaction-count')
//   counters.forEach((el) => {
//     const { type } = el.dataset
//     if (type && reactions[type] !== undefined) {
//       el.textContent = String(reactions[type])
//     }
//   })
// }

async function incrementForumReaction(forumId: string, type: string): Promise<void> {
  const ref = doc(db, 'forum_reactions_counts', forumId)
  await updateDoc(ref, {
    [type]: increment(1)
  })
}

const debounceMap = new WeakMap<HTMLElement, number>()

export const handleReactionClick = (btn: HTMLElement) => {
  const container = btn.closest<HTMLElement>('.js-forum-reactions-container')
  if (!container) return

  const { forumId } = container.dataset
  const reactionType = btn.getAttribute('data-type')
  if (!forumId || !reactionType) return

  // ✅ コンテナ単位でクリック制限
  const lastClick = debounceMap.get(container) ?? 0
  const now = Date.now()

  if (now - lastClick < 500) {
    return // 500ms以内はすべてのリアクションを無視
  }

  debounceMap.set(container, now)

  incrementForumReaction(forumId, reactionType)
    .then(() => {
      // ✅ カウント表示を+1（即時反映）
      const countEl = btn.querySelector<HTMLElement>('.reaction-count')
      if (!countEl) return
      const current = parseInt(countEl.textContent || '0', 10)
      countEl.textContent = String(current + 1)
    })
    .catch((err) => {
      console.error('failed reaction increment:', err)
    })
}
